import { z } from 'zod'
import { TeenangerProcessHearingSchema } from './teenager-process-hearing.type'
import { addCustomIssue } from 'utils/schema.util'
import { isFilled } from 'utils/validate.util'
import { SystemMessages } from 'utils/enums/system-message.enum'

export const PendingProcessHearingSchema = z.object({
  id: z.number().nullish(),
  dataRecebimento: z.string(),
  dataUltimaAtualizacaoIntegraJudicial: z.string().nullish(),
  protocolo: z.string(),
  numeroProcesso: z.string(),
  categoria: z.string(),
  numeroCnj: z.string(),
  descricaoRito: z.string(),
  delegaciaCircunscricaoFato: z.string(),
  delegaciaRegistro: z.string(),
  delegaciaResponsavel: z.string(),
  nomeVara: z.string().nullish(),
  nomeComarca: z.string().nullish(),
  tipoDelito: z.string(),
  descricaoMunicipio: z.string().nullish(),
  status: z.string(),
  motivo: z.string().nullish(),
  justificativa: z.string().nullish(),
  notificacoes: z.array(z.string()).nullish(),
  adolescentes: z.array(TeenangerProcessHearingSchema).nullish(),
})

export const PendingProcessHearingFilterSchema = z
  .object({
    tipo: z.string().nullish(),
    numeroCnj: z.string().nullish(),
    categoria: z.string().nullish(),
    status: z.array(z.string()),
    promotoria: z.string().nullish(),
    excessao: z.boolean().nullish(),
  })
  .superRefine((fields, ctx) => {
    const addIssue = (field: string, message: string) => addCustomIssue(ctx, [field], message)

    if (fields.tipo === 'AVANCADO' && !fields.excessao && !isFilled(fields.promotoria)) {
      addIssue('promotoria', SystemMessages.MESSAGE_002)
    }
  })

export type PendingProcessHearingType = z.infer<typeof PendingProcessHearingSchema>
export type PendingProcessHearingFilterType = z.infer<typeof PendingProcessHearingFilterSchema>

export const PendingProcessHearingTypeDefaultValues: PendingProcessHearingType = {
  delegaciaCircunscricaoFato: '',
  delegaciaRegistro: '',
  delegaciaResponsavel: '',
  descricaoRito: '',
  numeroCnj: '',
  status: '',
  tipoDelito: '',
  dataRecebimento: '',
  protocolo: '',
  numeroProcesso: '',
  categoria: '',
}

export const PendingProcessHearingFilterDefaultValues: PendingProcessHearingFilterType = {
  tipo: 'NORMAL',
  promotoria: '',
  numeroCnj: '',
  categoria: '',
  status: ['PENDENTE'],
}
